import React, {useEffect, useState} from 'react';
import {Modal, ScrollView, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import Button from '../../elements/Button';
import Text from '../../elements/Text';
import Divider from '../../elements/Divider';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {BUTTON_TYPES} from '../../../utils/Constants';
import Checkbox from '../../elements/Checkbox';
import {tID} from '../../../utils/TestIdHelper';
import {
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
  RadioCheckedIcon,
  RadioUncheckedIcon,
} from '../../../utils/SvgIcons';

const DropdownOptionsDrawer = ({
  visible,
  title,
  onClose,
  buttons = [],
  onPressRadio,
  options = [],
  selectedOptions = [],
  multiSelect = false,
  modalStyle = {},
  containerStyle = {},
  modalViewStyle = {},
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const [selected, setSelected] = useState(selectedOptions);

  useEffect(() => {
    if (visible) {
      setSelected(selectedOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- snapshot selectedOptions only when the drawer opens; the default [] prop is a new array each render and would clobber in-progress selection
  }, [visible]);

  const onPressOption = (item, index) => {
    if (multiSelect) {
      const idx = selected.indexOf(item);
      let tempSelected = [...selected];
      if (idx !== -1) {
        let _ = tempSelected.splice(idx, 1);
      } else {
        tempSelected.push(item);
      }
      setSelected(tempSelected);
    } else {
      setSelected([item]);
    }
    if (onPressRadio) {
      onPressRadio(item, index);
    }
  };

  const onPressButton = options => {
    const selectedOptions = [...selected];
    if (options.onPress) {
      options.onPress(selectedOptions);
    }
    setSelected([]);
  };

  return (
    <Modal
      testID={tID('DropdownOptionsDrawer-Modal-Main')}
      transparent
      visible={visible}
      onRequestClose={() => onClose?.()}
      animationType="slide"
      style={modalStyle}>
      <View
        testID={tID('DropdownOptionsDrawer-View-Container')}
        style={[styles.container, containerStyle]}>
        <SafeAreaView
          testID={tID('DropdownOptionsDrawer-SafeAreaView-Container')}
          style={[styles.safeareaContainer, modalViewStyle]}>
          <View style={styles.bottomContainer}>
            <Text
              testID={tID('DropdownOptionsDrawer-Text-Title')}
              variation="Body1SemiBold"
              color={colors.textMuted}>
              {title}
            </Text>
            <ScrollView
              testID={tID('DropdownOptionsDrawer-ScrollView-1')}
              style={styles.marginTop16}>
              {options.map((item, index) => (
                <View
                  testID={tID(`DropdownOptionsDrawer-View-Option${index + 1}`)}
                  key={index}>
                  <View key={index} style={styles.paddingVertical16}>
                    <Checkbox
                      topMargin={0}
                      selected={selected.includes(item)}
                      checkboxStyle={styles.checkboxStyle}
                      title={item}
                      checkedImage={
                        multiSelect ? (
                          <CheckboxCheckedIcon />
                        ) : (
                          <RadioCheckedIcon />
                        )
                      }
                      unCheckedImage={
                        multiSelect ? (
                          <CheckboxUncheckedIcon />
                        ) : (
                          <RadioUncheckedIcon />
                        )
                      }
                      onPress={() => onPressOption(item, index)}
                      titleStyle={styles.radioTitle(selected.includes(item))}
                    />
                  </View>
                  <Divider top={0} />
                </View>
              ))}

              {/* {multiSelect &&
                options.map((item, index) => (
                  <View key={index}>
                    <View key={index} style={styles.paddingVertical16}>
                      <Checkbox
                        topMargin={0}
                        selected={selected.includes(item)}
                        title={item}
                        checkedImage={<CheckboxCheckedIcon />}
                        unCheckedImage={<CheckboxUncheckedIcon />}
                        onPress={() => onPressOption(item, index)}
                        titleStyle={styles.radioTitle(selected.includes(item))}
                      />
                    </View>
                    <Divider top={0} />
                  </View>
                ))} */}
            </ScrollView>
            {buttons.length > 0 && (
              <View
                testID={tID('DropdownOptionsDrawer-View-ButtonsContainer')}
                style={styles.buttonsContainer}>
                {buttons.map((button, index) => (
                  <Button
                    testID={tID(`DropdownOptionsDrawer-Button-${index + 1}`)}
                    key={index}
                    style={[styles.button, {marginLeft: index == 0 ? 0 : 16}]}
                    buttonType={button.buttonType}
                    titleColor={
                      button.buttonType == BUTTON_TYPES.Filled
                        ? colors.textOnAccent
                        : undefined
                    }
                    title={button.title}
                    onPress={() => onPressButton(button)}
                  />
                ))}
              </View>
            )}
          </View>
        </SafeAreaView>
      </View>
    </Modal>
  );
};

export default DropdownOptionsDrawer;
